import { createAction, props } from '@ngrx/store';
import { ILocalPageOutputDto } from '@shared/interfaces/orga-response.interface';
import {
  ChatDto,
  ChatMessageListDto,
  ContactChatMemberDto,
  ContactListDto,
  LocationChatMemberDto,
  LocationListDto,
} from '@server-models';
import { ISharedChatPagination } from '@shared/components/chat/interfaces/shared-chat-pagination.interface';
import { IPaginationParams } from '@shared/interfaces/pagination-params.interface';

export const initChat = createAction('[Chat-Shared] Init Chat', props<{ issueId: any }>());

export const initChatSuccess = createAction('[Chat-Shared] Init Chat Success', props<{ chat: ChatDto }>());

export const initChatFail = createAction('[Chat-Shared] Init Chat Fail', props<{ error: any }>());

export const getChat = createAction('[Chat-Shared] Get Chat', props<{ chatId: number }>());

export const getChatSuccess = createAction('[Chat-Shared] Get Chat Success', props<{ chat: ChatDto }>());

export const getChatFail = createAction('[Chat-Shared] Get Chat Fail', props<{ error: any }>());

export const initMessagePolling = createAction(
  '[Chat-Shared] Init Message Polling'
);

export const messagePollingSuccess = createAction(
  '[Chat-Shared] Message Polling Success',
  props<{ newItems: ChatMessageListDto[] }>()
);

export const stopMessagePolling = createAction(
  '[Chat-Shared] Stop Message Polling'
);

export const chatMessageSend = createAction(
  '[Chat-Shared] Chat Message Send Start',
  props<{ chatId: any; message: ChatMessageListDto; }>()
);

export const chatMessageSendSuccess = createAction(
  '[Chat-Shared] Chat Message Send Success',
  props<{ newMessage: ChatMessageListDto }>()
);

export const chatMessageSendFail = createAction('[Chat-Shared] Chat Message Send Fail', props<{ error: any }>());

export const chatMessageClear = createAction('[Chat-Shared] Chat Message Clear');

export const addChatMember = createAction(
  '[Chat-Shared] Add Chat Member',
  props<{ chatId: number; member: LocationChatMemberDto | ContactChatMemberDto }>()
);

export const addChatMemberSuccess = createAction(
  '[Chat-Shared] Add Chat Member Success',
  props<{ newMember: LocationChatMemberDto | ContactChatMemberDto }>()
);

export const addChatMemberFail = createAction('[Chat-Shared] Add Chat Member Fail', props<{ error: any }>());

export const removeChatMember = createAction(
  '[Chat-Shared] Remove Chat Member',
  props<{ chatId: number; member: LocationChatMemberDto | ContactChatMemberDto }>()
);

export const removeChatMemberSuccess = createAction(
  '[Chat-Shared] Remove Chat Member Success',
  props<{ removedMember: LocationChatMemberDto | ContactChatMemberDto }>()
);

export const removeChatMemberFail = createAction('[Chat-Shared] Remove Chat Member Fail', props<{ error: any }>());

export const removeMe = createAction('[Chat-Shared] Remove Me', props<{ chatId: number }>());

export const removeMeSuccess = createAction('[Chat-Shared] Remove Me Success');

export const removeMeFail = createAction('[Chat-Shared] Remove Me Fail', props<{ error: any }>());

export const addMe = createAction('[Chat-Shared] Add Me', props<{ chatId: number }>());

export const addMeSuccess = createAction('[Chat-Shared] Add Me Success');

export const addMeFail = createAction('[Chat-Shared] Add Me Fail', props<{ error: any }>());

export const deleteChatMessage = createAction(
  '[Chat-Shared] Delete Chat Message',
  props<{ chatId: number, chatMessageId?: number }>()
)

export const deleteChatMessageSuccess = createAction(
  '[Chat-Shared] Delete Chat Message Success',
  props<{ chatMessageId?: number }>()
)

export const deleteChatMessageFail = createAction(
  '[Chat-Shared] Delete Chat Message Fail',
  props<{ error: any }>()
)

export const clearChatStore = createAction(
  '[Chat-Shared] Clear Chat Store'
)
